<mat-form-field class="form-field" [appearance]="appearance">
    
    <mat-label>
        {{label}}
    </mat-label>

    <ng-container *ngIf="multiple; else issueTransactionAttributeSingleSelection">

        <mat-select [formControl]="formControl" multiple>
            <mat-option *ngFor="let attribute of attributes" [value]="attribute.value">
                {{attribute.display}}
            </mat-option>
        </mat-select>

    </ng-container>

    <ng-template #issueTransactionAttributeSingleSelection>

        <mat-select [formControl]="formControl">
            <mat-option *ngFor="let attribute of attributes" [value]="attribute.value">
                {{attribute.display}}
            </mat-option>
        </mat-select>

    </ng-template>
    
</mat-form-field>
